define('controllers/consoleApi/myScope.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('myScopeCtrl', ['$scope', '$q', '$state', '$rootScope', 'OpenApp', 'ngDialog', '$stateParams', 'projectManageService', 'biAnalyticService', 'auiDialog',
        function ($scope, $q, $state, $rootScope, OpenApp, ngDialog, $stateParams, projectManageService, biAnalyticService, auiDialog) {
            var projectKey = $stateParams.projectKey;
            var Model = $scope.Model = {};
            Model.projectScopedefult = {
                query:{
                    openType: {id: 0, name: '全部状态'},
                    senstiveType: {id: 2, name: '全部类型'},
                    dropApi: {apiID: -1, apiName: '全部 API'},
                    pagination:{
                        currentPage: 1,// 当前页
                        itemsPerPage: 5,// 默认每页个数
                        itemsPerPageBackUp: 5,
                        totalCount: 0,
                        noItems: "No Data",
                        pagesLength: 5,// 显示的页码数量,
                        onChange: queryProjScopeList
                    }
                }
            };
            $scope.viewFailedCause = viewFailedCause;
            $scope.reapply = reapply;
            $scope.senstiveChange = senstiveChange;
            $scope.openTypeChange = openTypeChange;
            $scope.apiChange = apiChange;
            Model.senstiveType = mainCons.oauthConstant.senstiveType;
            Model.openType = mainCons.oauthConstant.openType;
            init();
            function init() {
                projectManageService.getProjectInfo({projectKey: projectKey}).then(function (data) {
                    if (data && data.projectInfo) {
                        Model.myProject = data.projectInfo;
                        projectManageService.setProjectKey(Model.myProject.projectKey);
                        getApiList();
                        var param = {
                            req:{
                                projectID: Model.myProject.projectID
                            }
                        };
                        queryProjScopeList(param);
                        $scope.projectScopeStatus = mainCons.oauthConstant.projectScopeStatus;
                        $scope.projectScopeSenstive = mainCons.oauthConstant.projectScopeSenstive;
                    }
                });
            }

            function getApiList() {
                projectManageService.getProjectAPI(Model.myProject.projectID).then(function (resp) {
                    Model.isShowApi = true;
                    if (resp && resp.apiInfoList && resp.apiInfoList.length > 0) {
                        Model.isHaveApi = true;
                        Model.apiInfoList = resp.apiInfoList;
                        Model.dropApiList = [{apiID: -1, apiName: '全部 API'}];
                        if (Model.apiInfoList && Model.apiInfoList.length > 0) {
                            Model.apiInfoList.forEach(function (item) {
                                var apiObj = {};
                                apiObj.apiID = item.langInfo.apiID;
                                apiObj.apiName = item.langInfo.apiName;
                                Model.dropApiList.push(apiObj)
                            })
                        }
                    } else {
                        Model.isHaveApi = false;
                    }
                });
            }

            function viewFailedCause(data) {
                ngDialog.open({
                    template: 'pages/consoleApi/template/view.failed.cause.html',
                    className: '',
                    replace: true,
                    controller: ['$scope', function ($scopeList) {
                        $scopeList.auditRes = data.auditRes;
                        $scopeList.cancel = function () {
                            ngDialog.close();
                        }
                    }]
                })
            }

            //下拉框API
            function apiChange(item) {
                Model.apiID = ''
                if (Model.projectScopedefult.query.openType && Model.projectScopedefult.query.senstiveType) {
                    var params = {
                        req: {
                            projectID: Model.myProject.projectID
                        }
                    };
                    if (item.apiID != -1) {
                        Model.apiID = item.apiID;
                        params.req.apiID = item.apiID
                    }
                    if (Model.projectScopedefult.query.openType.id != 0) {
                        var statusList = [];
                        statusList.push(Model.projectScopedefult.query.openType.id);
                        params.req.statusList = statusList
                    }
                    if (Model.projectScopedefult.query.senstiveType.id != 2) {
                        params.req.senstive = Model.projectScopedefult.query.senstiveType.id
                    }
                    queryProjScopeList(params);
                }
            }

            //下拉框选择敏感类型
            function senstiveChange(item) {
                Model.senstive = ''
                if (Model.projectScopedefult.query.openType && Model.projectScopedefult.query.dropApi) {
                    var params = {
                        req: {
                            projectID: Model.myProject.projectID,
                        }
                    };
                    if (item.id != 2) {
                        Model.senstive = item.id;
                        params.req.senstive = item.id
                    }
                    if (Model.projectScopedefult.query.openType.id != 0) {
                        var statusList = [];
                        statusList.push(Model.projectScopedefult.query.openType.id);
                        params.req.statusList = statusList
                    }
                    if (Model.projectScopedefult.query.dropApi.apiID != -1) {
                        params.req.apiID = Model.projectScopedefult.query.dropApi.apiID
                    }
                    queryProjScopeList(params);
                }
            }

            //下拉框选择状态
            function openTypeChange(item) {
                Model.statusList = [];
                if (Model.projectScopedefult.query.senstiveType && Model.projectScopedefult.query.dropApi) {
                    var params = {
                        req: {
                            projectID: Model.myProject.projectID
                        }

                    };
                    if (item.id != 0) {
                        Model.statusList = [];
                        Model.statusList.push(item.id);
                        var statusList = [];
                        statusList.push(item.id);
                        params.req.statusList = statusList
                    }
                    if (Model.projectScopedefult.query.senstiveType.id != 2) {
                        params.req.senstive = Model.projectScopedefult.query.senstiveType.id
                    }
                    if (Model.projectScopedefult.query.dropApi.apiID != -1) {
                        params.req.apiID = Model.projectScopedefult.query.dropApi.apiID
                    }
                    queryProjScopeList(params);
                }
            }

            function queryProjScopeList(params) {
                var defer = $q.defer();
                var projScopeParams = {};
                projScopeParams.req = {};
                if (params) {
                    projScopeParams = params;
                } else {
                    projScopeParams.req.projectID = Model.myProject.projectID;
                    if(Model.apiID) projScopeParams.req.apiID = Model.apiID;
                    if(Model.senstive == '0'|| Model.senstive == '1') projScopeParams.req.senstive = Model.senstive;
                    if(Model.statusList && Model.statusList.length>0) projScopeParams.req.statusList = Model.statusList;
                }
                projScopeParams.req.fromRecCount = (Model.projectScopedefult.query.pagination.currentPage - 1) * (Model.projectScopedefult.query.pagination.itemsPerPage) + 1;
                projScopeParams.req.maxReqCount = Model.projectScopedefult.query.pagination.itemsPerPage;
                projScopeParams.req.lang = 'zh_CN';
                OpenApp.getUserProjScopeList(projScopeParams).then(function (res) {
                    if (res && res.resultCode == 0 && res.userProjScopeList) {
                        Model.projectScopeList = res.userProjScopeList;
                        Model.projectScopedefult.query.pagination.totalCount =res.totalCount;
                    }
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            function reapply(data) {
                ngDialog.open({
                    template: 'pages/consoleApi/template/scope.reapply.html',
                    className: '',
                    replace: true,
                    controller: ['$scope', function ($scopeList) {
                        $scopeList.Model = Model;
                        Model.data = data;
                        Model.data.applySco = '';
                        $scopeList.doSubmit = doSubmit;
                        $scopeList.cancel = cancel;
                        //控制提交按钮是否置灰
                        $scopeList.isGreenOrGray = function () {
                            return Model.data.applySco == '';
                        };
                        function cancel() {
                            ngDialog.close();
                        }
                        function doSubmit() {
                            if ($scopeList.isGreenOrGray()) return;
                            var defer = $q.defer();
                            var applyDesc = [
                                {
                                    scopeID:data.scopeID,
                                    scopeUrl:data.scopeUrl,
                                    applyReason:data.applySco
                                }
                            ];
                            var param = {
                                req:{
                                    projectID: Model.myProject.projectID,
                                    apiID: data.apiID,
                                    applyScopes: applyDesc
                                }
                            };
                            OpenApp.applyProjScopeList(param).then(function (res) {
                                if (res.resultCode == 0) {
                                    auiDialog.success('敏感Scope开通申请提交成功',function () {
                                        cancel();
                                        init();
                                    });
                                    defer.resolve();
                                } else {
                                    defer.reject();
                                    cancel();
                                    init();
                                }
                            }).catch(function () {
                                defer.reject();
                                cancel();
                                init();
                            });
                            return defer.promise;
                        }
                    }]
                })
            }
        }])
});

